import script from "./StreakFlame.vue?vue&type=script&setup=true&lang=js"
export * from "./StreakFlame.vue?vue&type=script&setup=true&lang=js"

import "./StreakFlame.vue?vue&type=style&index=0&id=54d8b1c6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d8b1c6"]])

export default __exports__